import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

function Footer() {
  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const jsonData = {};
    for (let [key, value] of data) {
      jsonData[key] = value;
    }
    fetch("/tzor", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isToken) {
          alert("ההודעה נשלחה בהצלחה.");
          window.location = "/";
        } else {
          alert("שליחת ההודעה נכשלה");
        }
      });
  }

  return (
    <footer className="bg-dark text-light pt-5 mt-5">
      <Container dir="rtl">
        <Row className="mb-4">
          <Col md={6}>
            <h5>צור קשר</h5>
            <p>כאן ניתן להשאיר הודעה ופרטים ליצירת קשר.</p>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="fname">
                <Form.Control type="text" name="firstname" placeholder="שם" required />
              </Form.Group>
              <Form.Group className="mb-3" controlId="email">
                <Form.Control type="email" name="theemail" placeholder="אימייל" required />
              </Form.Group>
              <Form.Group className="mb-3" controlId="subject">
                <Form.Control as="textarea" name="subject" rows={3} placeholder="ההודעה שלך" required />
              </Form.Group>
              <Button variant="light" type="submit">שליחה</Button>
            </Form>
          </Col>

          <Col md={6} className="text-end">
            <h6 className="mt-4">פיתוח וניהול:</h6>
            <p>אליהו פרש מתווך נדל"ן מספר רשיון 3252397</p>
          </Col>
        </Row>

        <hr className="bg-light" />

        <Row className="text-center small">
          <Col md={4} className="mb-2 mb-md-0">
            © כל הזכויות שמורות למנהל האתר אליהו פרש
          </Col>
          <Col md={4} className="mb-2 mb-md-0">
            <a href="/takanon" className="text-light text-decoration-underline">תקנון ומדיניות פרטיות</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
